<template><svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 18.1111H10.7778L5.88889 23V18.1111H1V1H26.6667V12" stroke="#0B3459" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.7222 21.7778H24.8333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.7778 24.8333V18.7222" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="21.1667" cy="18.7223" r="9.16667" fill="white"/>
<circle cx="21.1666" cy="18.7223" r="7.94444" fill="#EA6576"/>
<rect x="20.5557" y="13.2222" width="1.22222" height="11" fill="white"/>
<rect x="26.6667" y="18.1113" width="1.22222" height="11" transform="rotate(90 26.6667 18.1113)" fill="white"/>
</svg></template><script>export default {}</script>
